import React from 'react';
import PropTypes from 'prop-types';
import { BulletList } from 'web-ui-components/lib/typography/lists';
import { AttentionTile as AttentionTileComponent } from 'web-ui-components/lib/layout/content';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { WebsiteLink } from 'web-ui-components/lib/actions/links';
import { Checkbox as WebUICheckbox } from 'web-ui-components/lib/atoms/forms';

import withContent from '../../containers/withContent';
import attentionTileContent, { contentPropTypes } from './index.content';
import { Checkbox } from '../Form';
import withValidation from '../../containers/withValidation';
import { declarationWebLink } from '../../effectiveWarning/utils/constants';

const { fraudErrorMessage } = attentionTileContent;
export const AccountNumberInput = withValidation({
	validations: ['checked'],
	key: 'fraudAwareness',
	message: fraudErrorMessage,
})(Checkbox);

const AttentionTile = ({
	content,
	fraudAwareness,
	handleChange,
	id,
	isChecked,
	multiplePayees,
	useOriginalCheckbox,
	brandId,
	...validationProps
}) => (
	<AttentionTileComponent.FraudAwareness title={content.fraudTitle}>
		<StandardBody>
			{(multiplePayees ? content.fraudIntroMultiple : content.fraudIntroSingle).map((intro) => (
				<p key={intro}>{intro}</p>
			))}
			<BulletList items={content.fraudQuestions} />
			<p>{multiplePayees ? content.fraudRecoveryMultiple : content.fraudRecoverySingle}</p>
			<p>
				<span>
					{content.fraudMoreInformationBeforeLink}
					<WebsiteLink
						willOpenNewWindow
						linkText={content.fraudMoreInformationLinkName}
						url={declarationWebLink[brandId]}
					/>
					{content.fraudMoreInformationAfterLink}
				</span>
			</p>
			{!useOriginalCheckbox && (
				<AccountNumberInput
					id={id}
					label={multiplePayees ? content.fraudConfirmMultiple : content.fraudConfirmSingle}
					fraudAwareness={fraudAwareness}
					checked={fraudAwareness}
					{...validationProps}
					onChange={handleChange}
				/>
			)}
			{useOriginalCheckbox && (
				<WebUICheckbox
					checked={isChecked}
					fullWidth
					id="importBenCheckbox"
					label={multiplePayees ? content.fraudConfirmMultiple : content.fraudConfirmSingle}
					onChange={handleChange}
				/>
			)}
		</StandardBody>
	</AttentionTileComponent.FraudAwareness>
);

AttentionTile.propTypes = {
	content: PropTypes.shape(contentPropTypes),
	id: PropTypes.string.isRequired,
	fraudAwareness: PropTypes.bool.isRequired,
	handleChange: PropTypes.func.isRequired,
	brandId: PropTypes.string.isRequired,
	isChecked: PropTypes.bool,
	useOriginalCheckbox: PropTypes.bool,
	multiplePayees: PropTypes.bool,
};

AttentionTile.defaultProps = {
	useOriginalCheckbox: false,
	multiplePayees: false,
};

export default withContent({ content: attentionTileContent })(AttentionTile);
export { AttentionTile };
